import React from 'react';
import { FormattedMessage } from 'react-intl';
import { List } from 'semantic-ui-react';
import clsx from 'clsx';
import HoverListDescription from '@/components/list/HoverListDescription';

const UserFieldListItem = ({
  className,
  markdown,
  value,
  type,
}) => (
  <>
    <List.Header className={clsx('aridhia-user-field-list-item', 'mt-20', className)}>
      <strong><FormattedMessage id={`user.${type}.title`} /></strong>
    </List.Header>
    <HoverListDescription markdown={markdown} value={value} className="aridhia-user-list-description" />
  </>
);

export default UserFieldListItem;
